/**
 * Match searchText again 'what' (lowercase comparison).
 *
 * This is useful to aggregate e.g. a number of attributes or lists
 * of descriptions for a specific object and match against all of that
 * to determine whether it matches a specific searchText.
 *
 * Handles german umlaut ambiguity internally.
 *
 * Args:
 *   what (String | Array[String])
 *   searchText (String)
 */
export default function matchesFilter(what, searchText) {
  const specialCharToReplacement = {
    ü: 'ue',
    ö: 'oe',
    ä: 'ae',
    ß: 'ss',
  };

  function _normalize(text) {
    // Cast to lowercase and replace ambiguous special characters like
    // german umlauts in the things we compare with their non-special
    // replacement.
    let textNormalized = String(text).toLowerCase();
    for (const specialChar of Object.keys(specialCharToReplacement)) {
      const replacement = specialCharToReplacement[specialChar];
      textNormalized = textNormalized.replace(specialChar, replacement);
    }
    return textNormalized;
  }

  // Handle null given as input.
  searchText = searchText || '';
  const searchTextNormalized = _normalize(searchText);

  // Handle mixed cases correctly, e.g. if the attr is 'Füssen' and we
  // search for either 'füssen' we want search terms 'fuessen' and
  // 'füßen' to both match.
  function _matches(attr) {
    attr = String(attr);
    const attrNormalized = _normalize(attr);
    const textMatched = attrNormalized.indexOf(searchTextNormalized) !== -1;
    return textMatched;
  }

  if (Array.isArray(what)) {
    for (var i = 0; i < what.length; i++) {
      let attr = what[i];
      if (_matches(attr)) {
        return true;
      }
    }
    return false;
  } else {
    return _matches(what);
  }
}



// WEBPACK FOOTER //
// ./src/matchesFilter.js